<template>
  <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar dense color="grey lighten-5" flat>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-2">{{ labels.mainTitle }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-data-table :headers="headers" :items="itemList" class="elevation-1" :loading="loading">
                    <template v-slot:item="row">
                      <tr>
                        <td>{{ row.item.riskItem }}</td>
                        <td>{{ row.item.busCls }}</td>
                        <td>{{ row.item.dNAP }}</td>
                        <td>{{ row.item.premDue }}</td>
                        <td>{{ row.item.disc }}</td>
                        <td>{{ row.item.comm1 }}</td>
                        <td>{{ row.item.comm2 }}</td>
                        <td>{{ row.item.comm3 }}</td>
                        <td>{{ row.item.stamp }}</td>
                        <td>{{ row.item.fee }}</td>
                        <td>{{ row.item.tax }}</td>
                        <td>{{ row.item.applyGst }}</td>
                        <td style="text-align: center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" color="primary" text @click.prevent="doSelectItem(row.item)" :loading="policy.saving">
                                <v-icon>mdi-magnify</v-icon>
                              </v-btn>
                            </template>
                            <span>{{ labels.query }}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
                <v-flex xs12>
                  <v-card v-show="showExpandRiskTrailer">
                    <v-toolbar dense color="grey lighten-5" flat>
                      <v-icon>mdi-format-align-justify</v-icon>
                      <v-toolbar-title class="toolbar-title-3">Risk {{ labels.riskItem }} Summary</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn text icon @click="showExpandRiskTrailer = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xs3>
                            <v-text-field v-model="mainForm.acctNo1" :label="labels.acctNo1" disabled></v-text-field>
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs5>
                            <v-text-field v-model="mainForm.acctNoSfx" :label="labels.acctNoSfx" disabled></v-text-field>
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2>
                            <v-text-field v-model="mainForm.billCurr" :label="labels.billCurr" disabled></v-text-field>
                          </v-flex>

                          <v-flex xs4> </v-flex>
                          <v-flex xs2>
                            <v-text-field v-model="mainForm.nap" :label="labels.nap" disabled></v-text-field>
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2>
                            <v-text-field v-model="mainForm.premDue" :label="labels.premDue" disabled></v-text-field>
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2>
                            <v-text-field v-model="mainForm.applyGst" :label="labels.applyGst" disabled></v-text-field>
                          </v-flex>

                          <v-flex xs3> </v-flex>
                          <v-flex xs1>
                            <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.discPctAe" disabled></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-text-field
                              v-model="mainForm.discPct"
                              :label="labels.discPct"
                              disabled
                              @blur="doDisc"
                              v-num-mask="{ negative: true, intScale: 3, decScale: 4 }"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs1>
                            <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.discAe" disabled></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-text-field
                              v-model="mainForm.disc"
                              :label="labels.disc"
                              disabled
                              @blur="doPremGST"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2>
                            <v-text-field v-model="mainForm.premGst" :label="labels.premGst" disabled></v-text-field>
                          </v-flex>

                          <v-flex xs3>
                            <v-autocomplete
                              :label="labels.redBal1"
                              :items="yesnoList"
                              v-model="mainForm.redBal1"
                              item-text="label"
                              item-value="value"
                              data-vv-name="redBal1"
                              :data-vv-as="labels.redBal1"
                              :error-messages="errors.collect('redBal1')"
                              v-validate="'required'"
                              disabled
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs1>
                            <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.comm1pctAe" disabled></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-text-field
                              v-model="mainForm.comm1pct"
                              :label="labels.comm1pct"
                              disabled
                              @blur="doComm1"
                              v-num-mask="{ negative: true, intScale: 3, decScale: 4 }"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1>
                            <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.comm1ae" disabled></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-text-field
                              v-model="mainForm.comm1"
                              :label="labels.comm1"
                              disabled
                              @blur="doTotAcctNo1"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2> </v-flex>

                          <v-flex xs3> </v-flex>
                          <v-flex xs1>
                            <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.stampAe" disabled></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-text-field
                              v-model="mainForm.stamp"
                              :label="labels.stamp"
                              disabled
                              @blur="doTotAcctNo1"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                              :loading="stampLoading"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1>
                            <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.feeAe" disabled></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-text-field
                              v-model="mainForm.fee"
                              :label="labels.fee"
                              disabled
                              @blur="doTotAcctNo1"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                              :loading="feeLoading"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1>
                            <v-checkbox class="align-end justify-end" color="primary" v-model="mainForm.taxAe" disabled></v-checkbox>
                          </v-flex>
                          <v-flex xs2>
                            <v-text-field
                              v-model="mainForm.tax"
                              :label="labels.tax"
                              disabled
                              @blur="doTotAcctNo1"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                              :loading="taxLoading"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs3> </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2>
                            <v-text-field v-model="mainForm.polStamp" :label="labels.polStamp" disabled></v-text-field>
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2>
                            <v-text-field v-model="mainForm.polFee" :label="labels.polFee" disabled></v-text-field>
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2>
                            <v-text-field v-model="mainForm.polTax" :label="labels.polTax" disabled></v-text-field>
                          </v-flex>

                          <v-flex xs3> </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2>
                            <v-text-field v-model="mainForm.totAcctNo1" :label="labels.totAcctNo1" disabled></v-text-field>
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2> </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs2> </v-flex>

                          <v-flex xs12>
                            <v-card>
                              <v-expansion-panels>
                                <v-expansion-panel>
                                  <v-expansion-panel-header>
                                    <div>
                                      <v-icon>mdi-cash</v-icon><span class="headerTitle">{{ labels.otherBilling }}</span>
                                    </div>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-card>
                                      <v-card-text>
                                        <v-container fluid grid-list-lg>
                                          <v-layout row wrap>
                                            <v-flex xs3>
                                              <!-- <v-autocomplete
                                                :items="interList"
                                                v-model="mainForm.acctNo2"
                                                :label="labels.acctNo2"
                                                item-text="label"
                                                item-value="value"
                                                disabled
                                                :loading="interLoading"
                                                clearable
                                              ></v-autocomplete> -->
                                              <v-text-field v-model="mainForm.acctNo2" :label="labels.acctNo2" disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs5>
                                              <v-text-field v-model="mainForm.acctNo2Sfx" :label="labels.acctNoSfx" disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs3> </v-flex>

                                            <v-flex xs3>
                                              <v-autocomplete
                                                :label="labels.redBal2"
                                                :items="yesnoList"
                                                v-model="mainForm.redBal2"
                                                item-text="label"
                                                item-value="value"
                                                data-vv-name="redBal2"
                                                :data-vv-as="labels.redBal2"
                                                :error-messages="errors.collect('redBal2')"
                                                v-validate="'required'"
                                                disabled
                                              ></v-autocomplete>
                                            </v-flex>
                                            <v-flex xs1>
                                              <v-checkbox
                                                class="align-end justify-end"
                                                color="primary"
                                                v-model="mainForm.comm2pctAe"
                                                disabled
                                              ></v-checkbox>
                                            </v-flex>
                                            <v-flex xs2>
                                              <v-text-field
                                                v-model="mainForm.comm2pct"
                                                :label="labels.comm2pct"
                                                disabled
                                                @blur="doComm2"
                                                v-num-mask="{ negative: true, intScale: 3, decScale: 4 }"
                                              ></v-text-field>
                                            </v-flex>
                                            <v-flex xs1>
                                              <v-checkbox
                                                class="align-end justify-end"
                                                color="primary"
                                                v-model="mainForm.comm2ae"
                                                disabled
                                              ></v-checkbox>
                                            </v-flex>
                                            <v-flex xs2>
                                              <v-text-field
                                                v-model="mainForm.comm2"
                                                :label="labels.comm2"
                                                disabled
                                                @blur="doTotAcctNo2"
                                                v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                              ></v-text-field>
                                            </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs2> </v-flex>

                                            <v-flex xs3> </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs2>
                                              <v-text-field v-model="mainForm.totAcctNo2" :label="labels.totAcctNo2" disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs2> </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs2> </v-flex>

                                            <v-flex xs12>
                                              <v-divider></v-divider>
                                            </v-flex>

                                            <v-flex xs3>
                                              <!-- <v-autocomplete
                                                :items="interList"
                                                v-model="mainForm.acctNo3"
                                                :label="labels.acctNo3"
                                                item-text="label"
                                                item-value="value"
                                                disabled
                                                :loading="interLoading"
                                                clearable
                                              ></v-autocomplete> -->
                                              <v-text-field v-model="mainForm.acctNo3" :label="labels.acctNo3" disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs5>
                                              <v-text-field v-model="mainForm.acctNo3Sfx" :label="labels.acctNoSfx" disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs3> </v-flex>

                                            <v-flex xs3>
                                              <v-autocomplete
                                                :label="labels.redBal3"
                                                :items="yesnoList"
                                                v-model="mainForm.redBal3"
                                                item-text="label"
                                                item-value="value"
                                                data-vv-name="redBal3"
                                                :data-vv-as="labels.redBal2"
                                                :error-messages="errors.collect('redBal3')"
                                                v-validate="'required'"
                                                disabled
                                              ></v-autocomplete>
                                            </v-flex>
                                            <v-flex xs1>
                                              <v-checkbox
                                                class="align-end justify-end"
                                                color="primary"
                                                v-model="mainForm.comm3pctAe"
                                                disabled
                                              ></v-checkbox>
                                            </v-flex>
                                            <v-flex xs2>
                                              <v-text-field
                                                v-model="mainForm.comm3pct"
                                                :label="labels.comm3pct"
                                                disabled
                                                @blur="doComm3"
                                                v-num-mask="{ negative: true, intScale: 3, decScale: 4 }"
                                              ></v-text-field>
                                            </v-flex>
                                            <v-flex xs1>
                                              <v-checkbox
                                                class="align-end justify-end"
                                                color="primary"
                                                v-model="mainForm.comm3ae"
                                                disabled
                                              ></v-checkbox>
                                            </v-flex>
                                            <v-flex xs2>
                                              <v-text-field
                                                v-model="mainForm.comm3"
                                                :label="labels.comm3"
                                                disabled
                                                @blur="doTotAcctNo3"
                                                v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                              ></v-text-field>
                                            </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs2> </v-flex>

                                            <v-flex xs3> </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs2>
                                              <v-text-field v-model="mainForm.totAcctNo3" :label="labels.totAcctNo3" disabled></v-text-field>
                                            </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs2> </v-flex>
                                            <v-flex xs1> </v-flex>
                                            <v-flex xs2> </v-flex>
                                          </v-layout>
                                        </v-container>
                                      </v-card-text>
                                    </v-card>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                                <v-expansion-panel>
                                  <v-expansion-panel-header>
                                    <div>
                                      <v-icon>mdi-cash</v-icon><span class="headerTitle">{{ labels.coRiSummary }}</span>
                                    </div>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-card>
                                      <v-card-text>
                                        <v-container fluid grid-list-lg>
                                          <v-layout row wrap>
                                            <v-flex xs4> </v-flex>
                                            <v-flex xs2>
                                              <v-subheader class="queryLabel" :loading="coRiLoading">{{ labels.si }}</v-subheader>
                                            </v-flex>
                                            <v-flex xs2>
                                              <v-subheader class="queryLabel" :loading="coRiLoading">{{ labels.sharePct }}</v-subheader>
                                            </v-flex>
                                            <v-flex xs4> </v-flex>

                                            <v-flex xs4>
                                              <v-subheader class="queryLabel">{{ labels.coIns }}</v-subheader>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dCoinsSI }}</div>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dCoinsSIPct }}</div>
                                            </v-flex>
                                            <v-flex xs4> </v-flex>

                                            <!-- gross -->
                                            <v-flex xs4>
                                              <v-subheader class="queryLabel">{{ labels.gross }}</v-subheader>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dSI }}</div>
                                            </v-flex>
                                            <v-flex xs2> </v-flex>
                                            <v-flex xs4> </v-flex>

                                            <!-- stats -->
                                            <v-flex xs4>
                                              <v-subheader class="queryLabel">{{ labels.stats }}</v-subheader>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dStatSI }}</div>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dStatSIPct }}</div>
                                            </v-flex>
                                            <v-flex xs4> </v-flex>

                                            <!-- fac -->
                                            <v-flex xs4>
                                              <v-subheader class="queryLabel">{{ labels.fac }}</v-subheader>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dFacSI }}</div>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dFacSIPct }}</div>
                                            </v-flex>
                                            <v-flex xs4> </v-flex>

                                            <!-- surplus -->
                                            <v-flex xs4>
                                              <v-subheader class="queryLabel">{{ labels.surplus }}</v-subheader>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dTtySI }}</div>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dTtySIPct }}</div>
                                            </v-flex>
                                            <v-flex xs4> </v-flex>

                                            <!-- net -->
                                            <v-flex xs4>
                                              <v-subheader class="queryLabel">{{ labels.net }}</v-subheader>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dNetSI }}</div>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dNetSIPct }}</div>
                                            </v-flex>
                                            <v-flex xs4> </v-flex>

                                            <!-- qs -->
                                            <v-flex xs4>
                                              <v-subheader class="queryLabel">{{ labels.qs }}</v-subheader>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dOthSI }}</div>
                                            </v-flex>
                                            <v-flex xs2>
                                              <div class="queryValue">{{ riForm.dOthSIPct }}</div>
                                            </v-flex>
                                            <v-flex xs4> </v-flex>
                                          </v-layout>
                                        </v-container>
                                      </v-card-text>
                                    </v-card>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="policy.saving" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'
import { formatYesNo } from '@/utils/boolean'
// import { formatDisplayDate2 } from '@/utils/date'
import { POLICYGENERAL_LOAD_DATA } from '@/store/types'
import { removeFormatNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        mainTitle: 'Risk Trailer',
        query: 'Query',
        riskItem: '',
        acctNo1: 'Billing A/C',
        acctNoSfx: 'Suffix',
        billCurr: 'Billing Currency',
        nap: 'Net Annual Premium (NAP)',
        premDue: 'Premium Due',
        applyGst: 'Apply GST',
        discPct: 'Discount %',
        disc: 'Discount',
        premGst: 'GST Premium',
        redBal1: 'Reducing Balance',
        comm1pct: 'Commission %',
        comm1: 'Commission',
        stamp: 'Risk Stamp',
        fee: 'Risk Fee',
        tax: 'Risk Tax',
        polStamp: 'Policy Stamp',
        polFee: 'Policy Fee',
        polTax: 'Policy Tax',
        totAcctNo1: 'Total After Account(1)',
        save: 'Save',
        otherBilling: 'Other Billing A/Cs',
        coRiSummary: 'CO/RI Summary',
        acctNo2: 'Account 2',
        acctNo3: 'Account 3',
        redBal2: 'Reducing Balance',
        redBal3: 'Reducing Balance',
        comm2pct: 'Commission %',
        comm2: 'Commission',
        totAcctNo2: 'Total After Account(2)',
        comm3pct: 'Commission %',
        comm3: 'Commission',
        totAcctNo3: 'Total After Account(3)',
        si: 'Sum Insured',
        sharePct: 'Share %',
        coIns: 'Coinsurance',
        gross: 'Gross',
        stats: 'Statutory',
        fac: 'Facultative',
        surplus: 'Surplus',
        net: 'Net',
        qs: 'Quota Share',
        exit: 'Exit',
        proceed: 'Proceed'
      },
      loading: false,
      policy: {
        loading: false,
        saving: false
      },
      headers: [
        { text: 'Risk', align: 'left', value: 'riskItem' },
        { text: 'Class', value: 'busCls' },
        { text: 'NAP', value: 'dNAP' },
        { text: 'PD', value: 'premDue' },
        { text: 'Disc', value: 'disc' },
        { text: 'Comm1', value: 'comm1' },
        { text: 'Comm2', value: 'comm2' },
        { text: 'Comm3', value: 'comm3' },
        { text: 'R.Stamp', value: 'stamp' },
        { text: 'R.Fee', value: 'fee' },
        { text: 'R.Tax', value: 'tax' },
        { text: 'Apply GST', value: 'applyGst' },
        { text: 'Actions', value: 'action', align: 'center' }
      ],
      itemList: [],
      showExpandRiskTrailer: true,
      mainForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        acctNo1: undefined,
        acctNoSfx: undefined,
        billCurr: undefined,
        nap: undefined,
        premDue: undefined,
        applyGst: undefined,
        discPctAe: undefined,
        discPct: undefined,
        discAe: undefined,
        disc: undefined,
        premGst: undefined,
        redBal1: undefined,
        comm1pctAe: undefined,
        comm1pct: undefined,
        comm1ae: undefined,
        comm1: undefined,
        stampAe: undefined,
        stamp: undefined,
        feeAe: undefined,
        fee: undefined,
        taxAe: undefined,
        tax: undefined,
        polStamp: undefined,
        polFee: undefined,
        polTax: undefined,
        totAcctNo1: undefined,
        dDisc: undefined,
        dComm1: undefined,
        dRiskStamp: undefined,
        dRiskFee: undefined,
        dRiskTax: undefined,
        acctNo2: undefined,
        acctNo2Sfx: undefined,
        redBal2: undefined,
        comm2pctAe: undefined,
        comm2pct: undefined,
        comm2ae: undefined,
        comm2: undefined,
        totAcctNo2: undefined,
        acctNo3: undefined,
        acctNo3Sfx: undefined,
        redBal3: undefined,
        comm3pctAe: undefined,
        comm3pct: undefined,
        comm3ae: undefined,
        comm3: undefined,
        totAcctNo3: undefined
      },
      riskItem: undefined,
      yesnoList: [
        {
          label: 'Yes',
          value: true
        },
        {
          label: 'No',
          value: false
        }
      ],
      stampLoading: false,
      feeLoading: false,
      taxLoading: false,
      interList: [],
      interLoading: false,
      showErrorDialog: false,
      riForm: {
        dCoinsSI: undefined,
        dCoinsSIPct: undefined,
        dSI: undefined,
        dStatSI: undefined,
        dStatSIPct: undefined,
        dFacSI: undefined,
        dFacSIPct: undefined,
        dTtySI: undefined,
        dTtySIPct: undefined,
        dNetSI: undefined,
        dNetSIPct: undefined,
        dOthSI: undefined,
        dOthSIPct: undefined
      },
      coRiLoading: false
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    polRisk() {
      return this.$store.state.underwriting
    },
    selectedRiskGrpNo() {
      return this.$store.state.underwriting.policy.selectedRiskGrpNo
    },
    selectedRiskNo() {
      return this.$store.state.underwriting.policy.selectedRiskNo
    },
    getFirstTrailerList() {
      return this.itemList.filter((risk) => {
        return risk.riskGrpNoRiskNo === this.itemList[0].riskGrpNoRiskNo
      })
    },
    getSelectedTrailer() {
      return this.itemList.filter((risk) => {
        return risk.riskItem === this.riskItem
      })
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    doInit() {
      this.getRiskTrailerList()
      this.getInterList()
    },
    async getRiskTrailerList() {
      const apiUrl = this.$store.state.underwriting.policyRiskItemSettings.menu.queryRiskTrailerList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.policyDto) {
            const commitObject = {
              data: result.data.policyDto
            }
            this.$store.commit(POLICYGENERAL_LOAD_DATA, commitObject)
          }
          this.displayRiskTrailerList(result.data.riskTrailerQueryList).then(() => {
            this.loading = false
            if (this.getFirstTrailerList.length > 0) {
              this.doSetRiskTrailer(this.getFirstTrailerList[0])
            } else {
              this.showExpandRiskTrailer = false
            }
          })
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async displayRiskTrailerList(result) {
      if (result) {
        this.itemList = []
        result.map((item) => {
          const convertItem = {
            riskItem: item.riskGrpNo.toString().padStart(2, '0') + '/' + item.riskNo.toString().padStart(3, '0'),
            riskGrpNo: item.riskGrpNo,
            riskNo: item.riskNo,
            dNAP: formatPrice(item.dNAP),
            dDiscPct: item.dDiscPct.toFixed(4),
            dComm1Pct: item.dComm1Pct.toFixed(4),
            dComm2Pct: item.dComm2Pct.toFixed(4),
            dComm3Pct: item.dComm3Pct.toFixed(4),
            busCls: item.busCls,
            premDue: formatPrice(item.premDue),
            disc: formatPrice(item.disc),
            comm1: formatPrice(item.comm1),
            comm2: formatPrice(item.comm2),
            comm3: formatPrice(item.comm3),
            stamp: formatPrice(item.stamp),
            fee: formatPrice(item.fee),
            tax: formatPrice(item.tax),
            applyGst: formatYesNo(item.applyGst),
            acctNo1Name: item.acctNo1Name,
            acctNoSfxDesc: item.acctNoSfxDesc,
            discPctAe: item.discPctAe,
            discPct: item.discPct.toFixed(4),
            discAe: item.discAe,
            premGst: formatPrice(item.premGst),
            comm1pctAe: item.comm1pctAe,
            comm1pct: item.comm1pct.toFixed(4),
            comm1ae: item.comm1ae,
            stampAe: item.stampAe,
            feeAe: item.feeAe,
            taxAe: item.taxAe,
            acctNo2Name: item.acctNo2Name,
            acctNo2SfxDesc: item.acctNo2SfxDesc,
            comm2pctAe: item.comm2pctAe,
            comm2pct: item.comm2pct.toFixed(4),
            comm2ae: item.comm2ae,
            acctNo3Name: item.acctNo3Name,
            acctNo3SfxDesc: item.acctNo3SfxDesc,
            comm3pctAe: item.comm3pctAe,
            comm3pct: item.comm3pct.toFixed(4),
            comm3ae: item.comm3ae,
            premGstrate: item.premGstrate
          }
          this.itemList.push(convertItem)
        })
      } else {
        this.itemList = []
      }
    },
    doSelectItem(data) {
      this.showExpandRiskTrailer = true
      this.doSetRiskTrailer(data)
    },
    async doSetRiskTrailer(data) {
      this.riskItem = data.riskItem
      this.labels.riskItem = data.riskItem
      this.mainForm.riskGrpNo = data.riskGrpNo
      this.mainForm.riskNo = data.riskNo
      this.mainForm.acctNo1 = this.polMaster.acctNo1 + ' - ' + data.acctNo1Name
      this.mainForm.acctNoSfx = data.acctNoSfxDesc
      this.mainForm.billCurr = this.polMaster.billCurr + ' - ' + this.polMaster.billCurrRate.toFixed(6)
      this.mainForm.nap = data.dNAP
      this.mainForm.premDue = data.premDue
      this.mainForm.applyGst = data.applyGst
      this.mainForm.discPctAe = data.discPctAe
      if (this.mainForm.discPctAe === false) {
        this.mainForm.discPct = data.discPct
      } else {
        this.mainForm.discPct = data.dDiscPct
      }

      this.mainForm.discAe = data.discAe
      this.mainForm.disc = data.disc
      this.mainForm.premGst = data.premGst

      this.mainForm.redBal1 = this.polMaster.redBal1
      this.mainForm.comm1pctAe = data.comm1pctAe
      this.mainForm.comm1pct = data.comm1pct
      this.mainForm.comm1ae = data.comm1ae
      if (this.mainForm.comm1ae === true) {
        if (this.mainForm.redBal1 === true) {
          this.mainForm.comm1 = formatPrice(
            (parseFloat(removeFormatNumber(this.mainForm.premDue)) + parseFloat(removeFormatNumber(this.mainForm.disc))) *
              (parseFloat(removeFormatNumber(this.mainForm.comm1pct)) / 100) *
              -1
          )
        } else {
          this.mainForm.comm1 = formatPrice(
            ((parseFloat(removeFormatNumber(this.mainForm.premDue)) * parseFloat(removeFormatNumber(this.mainForm.comm1pct))) / 100) * -1
          )
        }
      } else {
        this.mainForm.comm1 = data.comm1
      }

      this.mainForm.stampAe = data.stampAe
      if (this.mainForm.stampAe === true) {
        await this.doRiskStamp()
      } else {
        this.mainForm.stamp = data.stamp
      }

      this.mainForm.feeAe = data.feeAe
      if (this.mainForm.feeAe === true) {
        await this.doRiskFee()
      } else {
        this.mainForm.fee = data.fee
      }
      this.mainForm.taxAe = data.taxAe
      if (this.mainForm.taxAe === true) {
        await this.doRiskTax()
      } else {
        this.mainForm.tax = data.tax
      }
      this.mainForm.polStamp = formatPrice(this.polMaster.polStamp)
      this.mainForm.polFee = formatPrice(this.polMaster.polFee)
      this.mainForm.polTax = formatPrice(this.polMaster.polTax)
      this.doTotAcctNo1()

      // Other Billing A/Cs
      if (this.polMaster.acctNo2 === '') {
        this.mainForm.acctNo2 = ''
      } else {
        this.mainForm.acctNo2 = this.polMaster.acctNo2 + ' - ' + data.acctNo2Name
      }
      if (data.acctNo2SfxDesc !== null && data.acctNo2SfxDesc !== undefined && data.acctNo2SfxDesc !== '') {
        this.mainForm.acctNo2Sfx = data.acctNo2SfxDesc
      } else {
        this.mainForm.acctNo2Sfx = ''
      }
      this.mainForm.redBal2 = this.polMaster.redBal2
      this.mainForm.comm2pctAe = data.comm2pctAe
      this.mainForm.comm2pct = data.comm2pct
      this.mainForm.comm2ae = data.comm2ae
      if (this.mainForm.comm2ae === true) {
        if (this.mainForm.redBal2 === true) {
          this.mainForm.comm2 = formatPrice(
            (parseFloat(removeFormatNumber(this.mainForm.premDue)) +
              parseFloat(removeFormatNumber(this.mainForm.comm1)) +
              parseFloat(removeFormatNumber(this.mainForm.disc))) *
              (parseFloat(removeFormatNumber(this.mainForm.comm2pct)) / 100) *
              -1
          )
        } else {
          this.mainForm.comm2 = formatPrice(
            ((parseFloat(removeFormatNumber(this.mainForm.premDue)) * parseFloat(removeFormatNumber(this.mainForm.comm2pct))) / 100) * -1
          )
        }
      } else {
        this.mainForm.comm2 = data.comm2
      }

      this.doTotAcctNo2()

      if (this.polMaster.acctNo3 === '') {
        this.mainForm.acctNo3 = ''
      } else {
        this.mainForm.acctNo3 = this.polMaster.acctNo3 + ' - ' + data.acctNo3Name
      }

      if (data.acctNo3SfxDesc !== null && data.acctNo3SfxDesc !== undefined && data.acctNo3SfxDesc !== '') {
        this.mainForm.acctNo3Sfx = data.acctNo3SfxDesc
      } else {
        this.mainForm.acctNo3Sfx = ''
      }
      this.mainForm.redBal3 = this.polMaster.redBal3
      this.mainForm.comm3pctAe = data.comm3pctAe
      this.mainForm.comm3pct = data.comm3pct
      this.mainForm.comm3ae = data.comm3ae
      if (this.mainForm.comm3ae === true) {
        if (this.mainForm.redBal3 === true) {
          this.mainForm.comm3 = formatPrice(
            (parseFloat(removeFormatNumber(this.mainForm.premDue)) +
              parseFloat(removeFormatNumber(this.mainForm.comm1)) +
              parseFloat(removeFormatNumber(this.mainForm.comm2)) +
              parseFloat(removeFormatNumber(this.mainForm.disc))) *
              (parseFloat(removeFormatNumber(this.mainForm.comm3pct)) / 100) *
              -1
          )
        } else {
          this.mainForm.comm3 = formatPrice(
            ((parseFloat(removeFormatNumber(this.mainForm.premDue)) * parseFloat(removeFormatNumber(this.mainForm.comm3pct))) / 100) * -1
          )
        }
      } else {
        this.mainForm.comm3 = data.comm3
      }

      this.doTotAcctNo3()

      this.getCoRiSummary()
    },
    doDisc() {
      if (this.mainForm.discAe === false) {
        this.mainForm.disc = this.getSelectedTrailer[0].disc
      } else {
        // • ( [polRisk.premDue] * [polRiskk.discPct] / 100 ) * -1
        this.mainForm.disc = formatPrice(((this.getSelectedTrailer[0].premDue * this.mainForm.discPct) / 100) * -1)
      }
      this.doPremGST()
    },
    doPremGST() {
      if (this.mainForm.applyGst === false) {
        this.mainForm.premGst = formatPrice(0)
      } else {
        this.mainForm.premGst = formatPrice(
          ((parseFloat(removeFormatNumber(this.mainForm.premDue)) + parseFloat(removeFormatNumber(this.mainForm.disc))) *
            parseFloat(removeFormatNumber(this.getSelectedTrailer[0].premGstrate))) /
            100
        )
      }
      this.doTotAcctNo1()
    },
    doComm1() {
      if (this.mainForm.comm1ae === true) {
        if (this.mainForm.redBal1 === true) {
          this.mainForm.comm1 = formatPrice(
            (parseFloat(removeFormatNumber(this.mainForm.premDue)) + parseFloat(removeFormatNumber(this.mainForm.disc))) *
              (parseFloat(removeFormatNumber(this.mainForm.comm1pct)) / 100) *
              -1
          )
        } else {
          this.mainForm.comm1 = formatPrice(
            ((parseFloat(removeFormatNumber(this.mainForm.premDue)) * parseFloat(removeFormatNumber(this.mainForm.comm1pct))) / 100) * -1
          )
        }
      } else {
        this.mainForm.comm1 = this.getSelectedTrailer[0].comm1
      }
      this.doTotAcctNo1()
    },
    async doRiskStamp() {
      const apiUrl = this.$store.state.underwriting.policyRiskItemSettings.menu.getRiskStamp
      if (apiUrl) {
        try {
          this.stampLoading = true
          var dEffDate = new Date(this.polMaster.tranDate)
          if (this.polMaster.comDate !== undefined && this.polMaster.comDate !== null) {
            dEffDate = new Date(this.polMaster.comDate)
          }
          const expand = {
            branch: this.polMaster.branch,
            dRi: this.polMaster.dri,
            effDate: dEffDate,
            premDue: removeFormatNumber(this.mainForm.premDue),
            disc: removeFormatNumber(this.mainForm.disc)
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            const { data } = result
            this.mainForm.stamp = formatPrice(data.data)
          }
          this.stampLoading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doRiskFee() {
      const apiUrl = this.$store.state.underwriting.policyRiskItemSettings.menu.getRiskFee
      if (apiUrl) {
        try {
          this.feeLoading = true
          var dEffDate = new Date(this.polMaster.tranDate)
          if (this.polMaster.comDate !== undefined && this.polMaster.comDate !== null) {
            dEffDate = new Date(this.polMaster.comDate)
          }
          const expand = {
            branch: this.polMaster.branch,
            dRi: this.polMaster.dri,
            effDate: dEffDate,
            premDue: removeFormatNumber(this.mainForm.premDue),
            disc: removeFormatNumber(this.mainForm.disc)
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            const { data } = result
            this.mainForm.fee = formatPrice(data.data)
          }
          this.feeLoading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doRiskTax() {
      const apiUrl = this.$store.state.underwriting.policyRiskItemSettings.menu.getRiskTax
      if (apiUrl) {
        try {
          this.taxLoading = true
          var dEffDate = new Date(this.polMaster.tranDate)
          if (this.polMaster.comDate !== undefined && this.polMaster.comDate !== null) {
            dEffDate = new Date(this.polMaster.comDate)
          }
          const expand = {
            branch: this.polMaster.branch,
            dRi: this.polMaster.dri,
            effDate: dEffDate,
            premDue: removeFormatNumber(this.mainForm.premDue),
            disc: removeFormatNumber(this.mainForm.disc)
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            const { data } = result
            this.mainForm.tax = formatPrice(data.data)
          }
          this.taxLoading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doTotAcctNo1() {
      // 2020-09-30 LYT OS-463
      this.mainForm.totAcctNo1 =
        parseFloat(removeFormatNumber(this.polMaster.polPd)) +
        parseFloat(removeFormatNumber(this.polMaster.polStamp)) +
        parseFloat(removeFormatNumber(this.polMaster.polFee)) +
        parseFloat(removeFormatNumber(this.polMaster.polTax)) +
        parseFloat(removeFormatNumber(this.polMaster.comm1)) +
        parseFloat(removeFormatNumber(this.mainForm.comm1)) -
        parseFloat(removeFormatNumber(this.getSelectedTrailer[0].comm1)) +
        parseFloat(removeFormatNumber(this.polMaster.disc)) +
        parseFloat(removeFormatNumber(this.mainForm.disc)) -
        parseFloat(removeFormatNumber(this.getSelectedTrailer[0].disc)) +
        parseFloat(removeFormatNumber(this.polMaster.riskStamp)) +
        parseFloat(removeFormatNumber(this.mainForm.stamp)) -
        parseFloat(removeFormatNumber(this.getSelectedTrailer[0].stamp)) +
        parseFloat(removeFormatNumber(this.polMaster.riskFee)) +
        parseFloat(removeFormatNumber(this.mainForm.fee)) -
        parseFloat(removeFormatNumber(this.getSelectedTrailer[0].fee)) +
        parseFloat(removeFormatNumber(this.polMaster.riskTax)) +
        parseFloat(removeFormatNumber(this.mainForm.tax)) -
        parseFloat(removeFormatNumber(this.getSelectedTrailer[0].tax))
      this.mainForm.totAcctNo1 = formatPrice(this.mainForm.totAcctNo1)
      this.mainForm.dDisc = parseFloat(this.getSelectedTrailer[0].disc)
      this.mainForm.dComm1 = parseFloat(this.getSelectedTrailer[0].comm1)
      this.mainForm.dRiskStamp = parseFloat(this.getSelectedTrailer[0].stamp)
      this.mainForm.dRiskFee = parseFloat(this.getSelectedTrailer[0].fee)
      this.mainForm.dRiskTax = parseFloat(this.getSelectedTrailer[0].tax)
      this.doComm2pctAe()
      this.doTotAcctNo2()
    },
    async getInterList() {
      const apiUrl = this.$store.state.underwriting.policyRiskItemSettings.menu.interList
      if (apiUrl) {
        try {
          this.interLoading = true
          const expand = {
            acctNo1: this.polMaster.acctNo1,
            polType: this.polMaster.polType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            const { data } = result.data
            if (data) {
              this.$set(this, 'interList', data)
            }
          }
          this.interLoading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doComm2pctAe() {
      if (this.mainForm.comm2pctAe === false) {
        this.mainForm.comm2pct = this.getSelectedTrailer[0].comm2pct
      } else {
        this.mainForm.comm2pct = this.getSelectedTrailer[0].dComm2Pct
      }
      this.doComm2()
    },
    doComm2() {
      if (this.mainForm.comm2ae === true) {
        if (this.mainForm.redBal2 === true) {
          this.mainForm.comm2 = formatPrice(
            (parseFloat(removeFormatNumber(this.mainForm.premDue)) +
              parseFloat(removeFormatNumber(this.mainForm.comm1)) +
              parseFloat(removeFormatNumber(this.mainForm.disc))) *
              (parseFloat(removeFormatNumber(this.mainForm.comm2pct)) / 100) *
              -1
          )
        } else {
          this.mainForm.comm2 = formatPrice(
            ((parseFloat(removeFormatNumber(this.mainForm.premDue)) * parseFloat(removeFormatNumber(this.mainForm.comm2pct))) / 100) * -1
          )
        }
      } else {
        this.mainForm.comm2 = this.getSelectedTrailer[0].comm2
      }
      this.doTotAcctNo2()
    },
    doTotAcctNo2() {
      // 2020-09-30 LYT OS-463
      this.mainForm.totAcctNo2 =
        parseFloat(removeFormatNumber(this.mainForm.totAcctNo1)) +
        parseFloat(removeFormatNumber(this.polMaster.comm2)) +
        parseFloat(removeFormatNumber(this.mainForm.comm2)) -
        parseFloat(removeFormatNumber(this.getSelectedTrailer[0].comm2))
      this.mainForm.totAcctNo2 = formatPrice(this.mainForm.totAcctNo2)
      this.doComm3pctAe()
      this.doTotAcctNo3()
    },
    doComm3pctAe() {
      if (this.mainForm.comm3pctAe === false) {
        this.mainForm.comm3pct = this.getSelectedTrailer[0].comm3pct
      } else {
        this.mainForm.comm3pct = this.getSelectedTrailer[0].dComm3Pct
      }
      this.doComm3()
    },
    doComm3() {
      if (this.mainForm.comm3ae === true) {
        if (this.mainForm.redBal3 === true) {
          this.mainForm.comm3 = formatPrice(
            (parseFloat(removeFormatNumber(this.mainForm.premDue)) +
              parseFloat(removeFormatNumber(this.mainForm.comm1)) +
              parseFloat(removeFormatNumber(this.mainForm.comm2)) +
              parseFloat(removeFormatNumber(this.mainForm.disc))) *
              (parseFloat(removeFormatNumber(this.mainForm.comm3pct)) / 100) *
              -1
          )
        } else {
          this.mainForm.comm3 = formatPrice(
            ((parseFloat(removeFormatNumber(this.mainForm.premDue)) * parseFloat(removeFormatNumber(this.mainForm.comm3pct))) / 100) * -1
          )
        }
      } else {
        this.mainForm.comm3 = this.getSelectedTrailer[0].comm3
      }
      this.doTotAcctNo3()
    },
    doTotAcctNo3() {
      // 2020-09-30 LYT OS-463
      this.mainForm.totAcctNo3 =
        parseFloat(removeFormatNumber(this.mainForm.totAcctNo2)) +
        parseFloat(removeFormatNumber(this.polMaster.comm3)) +
        parseFloat(removeFormatNumber(this.mainForm.comm3)) -
        parseFloat(removeFormatNumber(this.getSelectedTrailer[0].comm3))
      this.mainForm.totAcctNo3 = formatPrice(this.mainForm.totAcctNo3)
    },
    async getCoRiSummary() {
      const apiUrl = this.$store.state.underwriting.policyRiskItemSettings.menu.coRiSummary
      if (apiUrl) {
        try {
          this.coRiLoading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.mainForm.riskGrpNo,
            riskNo: this.mainForm.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))

          if (result.data) {
            const { data } = result
            this.riForm.dCoinsSI = formatPrice(data.dCoinsSI)
            this.riForm.dCoinsSIPct = data.dCoinsSIPct.toFixed(6)
            this.riForm.dSI = formatPrice(data.dSI)
            this.riForm.dStatSI = formatPrice(data.dStatSI)
            this.riForm.dStatSIPct = data.dStatSIPct.toFixed(6)
            this.riForm.dFacSI = formatPrice(data.dFacSI)
            this.riForm.dFacSIPct = data.dFacSIPct.toFixed(6)
            this.riForm.dTtySI = formatPrice(data.dTtySI)
            this.riForm.dTtySIPct = data.dTtySIPct.toFixed(6)
            this.riForm.dNetSI = formatPrice(data.dNetSI)
            this.riForm.dNetSIPct = data.dNetSIPct.toFixed(6)
            this.riForm.dOthSI = formatPrice(data.dOthSI)
            this.riForm.dOthSIPct = data.dOthSIPct.toFixed(6)
          }
          this.coRiLoading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.policyRiskItemSettings.init !== 1) {
      this.$store.dispatch('policyRiskItemInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
